import { render, staticRenderFns } from "./BackupChildGuardians.vue?vue&type=template&id=1bf37eaa"
import script from "./BackupChildGuardians.vue?vue&type=script&lang=js"
export * from "./BackupChildGuardians.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports